export default __webpack_public_path__ + "static/media/icon-compassionate-leave.3fb57a85.svg";